<template>
    <div class="container">
        <md-dialog :md-active.sync="showDialogEdit" :md-click-outside-to-close="false">
            <md-dialog-title class="dialog-header">
                <span class="header-title">{{ labels.title }}</span>
            </md-dialog-title>
            <md-dialog-content class="dialog-content">
                <div class="form-container">
                    <!-- Información principal -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.cuenta }}</label>
                            <div class="field-value">{{ Item.cuenta }}</div>
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.name }}</label>
                            <md-field class="custom-field">
                                <md-input v-model="Item.descripcion" :placeholder="labels.name" />
                            </md-field>
                        </div>
                    </div>

                    <!-- Niif -->
                    <div class="form-field-full">
                        <label class="field-label">{{ labels.niif }}</label>
                        <md-field class="custom-field">
                            <select v-model="Item.niif" class="modern-select">
                                <option value="" disabled>{{ labels.sel }}</option>
                                <option v-for="planCons in listNiif" :key="planCons.id" :value="planCons.niif">
                                    {{ planCons.niif }}-{{ planCons.nameNiif }}
                                </option>
                            </select>
                        </md-field>
                    </div>

                    <!-- Opciones booleanas -->
                    <div class="boolean-options">
                        <div class="boolean-group">
                            <div class="boolean-field">
                                <label class="boolean-label">{{ labels.esf }}</label>
                                <select v-model="Item.esf" class="boolean-select">
                                    <option value="">{{ labels.not }}</option>
                                    <option value="X">{{ labels.yes }}</option>
                                </select>
                            </div>
                            <div class="boolean-field">
                                <label class="boolean-label">{{ labels.eri }}</label>
                                <select v-model="Item.eri" class="boolean-select">
                                    <option value="">{{ labels.not }}</option>
                                    <option value="X">{{ labels.yes }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="boolean-group">
                            <div class="boolean-field">
                                <label class="boolean-label">{{ labels.efe }}</label>
                                <select v-model="Item.efe" class="boolean-select">
                                    <option value="">{{ labels.not }}</option>
                                    <option value="X">{{ labels.yes }}</option>
                                </select>
                            </div>
                            <div class="boolean-field">
                                <label class="boolean-label">{{ labels.ecp }}</label>
                                <select v-model="Item.ecp" class="boolean-select">
                                    <option value="">{{ labels.not }}</option>
                                    <option value="X">{{ labels.yes }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- Interco -->
                    <div class="form-field-full">
                        <label class="field-label">{{ labels.interco }}</label>
                        <md-field class="custom-field">
                            <select v-model="Item.interco" class="modern-select">
                                <option value="" disabled>{{ labels.sel }}</option>
                                <option v-if="Item.interco && Item.interco !== ''" :value="Item.interco">
                                    {{ getIntercoDisplayValue(Item.interco) }}
                                </option>
                                <option value="">{{ labels.noGroup }}</option>
                                <option v-for="grupo in gruposInterco" :key="grupo.interco" :value="grupo.interco">
                                    {{ grupo.descripcion }}
                                </option>
                            </select>
                        </md-field>
                    </div>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="dialog-actions">
                <md-button class="md-raised cancel-btn" @click="closeDialog">
                    {{ labels.close }}
                </md-button>
                <md-button class="md-raised md-primary save-btn" @click="confirmSave">
                    {{ labels.save }}
                </md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import PlanCuentas from '../../services/PlanCuentas'
import GruposIntercos from '../../services/GruposIntercos'

export default {
    name: "EditarCuenta",
    props: ['showDialogEdit', 'Item', 'listNiif'],

    data: () => ({
        cuenta: "",
        esf: "",
        eri: "",
        efe: "",
        ecp: "",
        interco: "",
        niif: "",
        gruposInterco: [],
        originalItem: null,
        isSaving: false
    }),


    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar cuenta",
                    save: "Guardar",
                    close: "Cerrar",
                    cuenta: "Cuenta:",
                    name: "Nombre:",
                    niif: "Niif:",
                    esf: "Esf:",
                    eri: "Eri:",
                    efe: "Efe:",
                    ecp: "Ecp:",
                    interco: "Interco:",
                    sel: "Seleccione...",
                    yes: "SI",
                    not: "NO",
                    noGroup: "NO",
                }
            } else {
                return {
                    title: "Edit account",
                    save: "Save",
                    close: "Close",
                    cuenta: "Account:",
                    name: "Name:",
                    niif: "Niif:",
                    esf: "Esf:",
                    eri: "Eri:",
                    efe: "Efe:",
                    ecp: "Ecp:",
                    interco: "Interco:",
                    sel: "Select...",
                    yes: "Yes",
                    not: "No",
                    noGroup: "NO",
                }
            }
        },
        hasUnsavedChanges() {
            if (!this.originalItem || this.isSaving) return false;
            return JSON.stringify(this.Item) !== JSON.stringify(this.originalItem);
        }
    },

    watch: {
        Item: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    // Siempre resetear los valores originales cuando cambia el Item
                    this.originalItem = { ...newVal };
                }
            }
        },
        showDialogEdit: {
            handler(newVal) {
                if (newVal && this.Item) {
                    // PRIMERO cargar grupos interco, LUEGO setear valores
                    this.loadGruposInterco().then(() => {
                        this.originalItem = { ...this.Item };
                        this.isSaving = false;
                    });
                }
            },
            immediate: true
        }
    },

    methods: {
        confirmSave() {
            const message = this.$store.state._language == "es-ES"
                ? "¿Está seguro que desea guardar los cambios?"
                : "Are you sure you want to save the changes?";

            if (window.confirm(message)) {
                this.editPlanCuenta();
            }
        },

        editPlanCuenta() {
            if (this.Item.descripcion == "") {
                this.$toast.error("Diligenciar el campo Nombre")
            } else if (this.Item.niif == "") {
                this.$toast.error("Diligenciar el campo Niif")
            } else {

                this.isSaving = true;

                let form = {
                    'nombre': this.Item.descripcion,
                    'niif': this.Item.niif,
                    'esf': this.Item.esf == "SI" || this.Item.esf == "X" ? "X" : "",
                    'eri': this.Item.eri == "SI" || this.Item.eri == "X" ? "X" : "",
                    'efe': this.Item.efe == "SI" || this.Item.efe == "X" ? "X" : "",
                    'ecp': this.Item.ecp == "SI" || this.Item.ecp == "X" ? "X" : "",
                    'interco': this.Item.interco === '' ? null : this.Item.interco,
                    'id': this.Item.id,
                    'cuenta': this.Item.cuenta,
                    'vigencia': this.Item.vigencia,
                    'id_compania': this.Item.id_compania,
                    'codReporte': this.Item.codReporte,
                    'idUser': this.$store.state.userId,
                }

                PlanCuentas.planCuentasUpdate(form)
                    .then((res) => {
                        this.$toast.success(res.data.message)

                        const niifInfo = this.listNiif.find(niif => niif.niif == form.niif);
                        const nombreNiif = niifInfo ? niifInfo.nameNiif : '';

                        const grupoInterco = this.gruposInterco.find(g => g.interco == form.interco);
                        const intercoDescripcion = grupoInterco ? grupoInterco.descripcion : '';

                        const updatedItem = {
                            ...this.Item,
                            descripcion: form.nombre,
                            niif: form.niif,
                            nombre_niif: nombreNiif,
                            esf: form.esf,
                            eri: form.eri,
                            efe: form.efe,
                            ecp: form.ecp,
                            interco: form.interco,
                            intercoDescripcion: intercoDescripcion
                        };

                        this.originalItem = { ...updatedItem };

                        this.$emit('item-updated', updatedItem);

                        this.$emit('clicked', false);
                    })
                    .catch((err) => {
                        console.log(err)
                        this.$toast.error("Error al actualizar la cuenta")
                        this.isSaving = false;
                    })
            }
        },

        restoreOriginalValues() {
            if (this.originalItem) {
                Object.assign(this.Item, this.originalItem);
            }
        },

        getIntercoDisplayValue(intercoValue) {
            console.log('Buscando interco:', intercoValue, 'Tipo:', typeof intercoValue)
            console.log('Grupos disponibles:', this.gruposInterco)

            this.gruposInterco.forEach(grupo => {
                console.log(`Grupo - interco: ${grupo.interco}, Tipo: ${typeof grupo.interco}, Desc: ${grupo.descripcion}`)
            })

            if (!intercoValue || intercoValue === '') {
                return this.labels.noGroup;
            }

            // Buscar la descripción en los grupos interco cargados
            const grupo = this.gruposInterco.find(g => {
                console.log(`Comparando: ${g.interco} (${typeof g.interco}) con ${intercoValue} (${typeof intercoValue})`)
                return g.interco == intercoValue; // Usar == en lugar de === para comparación flexible
            });

            console.log('Grupo encontrado:', grupo)
            return grupo ? grupo.descripcion : `Grupo ${intercoValue}`;
        },

        closeDialog() {
            if (this.hasUnsavedChanges) {
                // Si no tienes SweetAlert, usa confirm nativo por ahora
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?";

                if (window.confirm(message)) {
                    this.restoreOriginalValues();
                    this.$emit('clicked', false);
                }
            } else {
                this.$emit('clicked', false);
            }
        },
        async loadGruposInterco() {
            try {
                const res = await GruposIntercos.getAllGruposIntercos();
                this.gruposInterco = res.data.gruposIntercos || [];
                console.log('Grupos interco cargados:', this.gruposInterco)
                return this.gruposInterco; // ← Agrega este return
            } catch (err) {
                console.error("Error loading grupos interco:", err);
                this.gruposInterco = [];
                return []; // ← Y este return
            }
        },
    }
}

</script>

<style scoped>
/* Header del diálogo */
.dialog-header {
    background: #34495e;
    color: white;
    padding: 20px 24px;
    margin: 0;
    border-bottom: 1px solid #2c3e50;
}

.header-title {
    font-size: 1.3rem;
    font-weight: 500;
}

.dialog-content {
    padding: 20px 24px;
}

.form-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* Grupos de formulario */
.form-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.form-field-full {
    width: 100%;
}

/* Labels y campos */
.field-label {
    display: block;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.field-value {
    padding: 12px 0;
    font-weight: 600;
    color: #34495e;
    font-size: 15px;
    border-bottom: 1px solid #ecf0f1;
}

/* Campos de formulario */
.custom-field {
    margin: 0;
}

.modern-select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #bdc3c7;
    border-radius: 4px;
    background: white;
    font-size: 14px;
    color: #2c3e50;
    outline: none;
    transition: border-color 0.2s ease;
}

.modern-select:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1);
}

/* Opciones booleanas */
.boolean-options {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e9ecef;
}

.boolean-group {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.boolean-field {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.boolean-label {
    font-weight: 500;
    color: #2c3e50;
    font-size: 14px;
    min-width: 60px;
}

.boolean-select {
    padding: 8px 12px;
    border: 1px solid #bdc3c7;
    border-radius: 4px;
    background: white;
    font-size: 14px;
    color: #2c3e50;
    outline: none;
    min-width: 80px;
    text-align: center;
}

.boolean-select:focus {
    border-color: #3498db;
}

/* Acciones del diálogo */
.dialog-actions {
    padding: 20px 24px;
    border-top: 1px solid #ecf0f1;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #f8f9fa;
}

.cancel-btn {
    background: #95a5a6 !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.save-btn {
    background: #3498db !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.cancel-btn:hover {
    background: #7f8c8d !important;
}

.save-btn:hover {
    background: #2980b9 !important;
}

/* Responsive */
@media (max-width: 768px) {
    .form-group {
        grid-template-columns: 1fr;
        gap: 16px;
    }
    
    .boolean-options {
        grid-template-columns: 1fr;
        gap: 16px;
    }
    
    .form-container {
        padding: 16px;
    }
    
    .dialog-actions {
        padding: 16px;
    }
}
</style>